import React from "react";
import NavbarDoctorOffice from "../../../NavbarDoctorOffice";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  Col,
  Input,
  Label,
  Row,
} from "reactstrap";
import CardHeaderTabs from "../../../../../@dhn/components/molecules/card-header-tabs";
import TabContent from "../../../../../@dhn/components/atoms/tab-content";
import useAction from "./use-action";
import EvaluationParameters from "../AppointmentConsultationProcess/tabs/EvaluationParameters/EvaluationParameters";
import Services from "../AppointmentConsultationProcess/tabs/Services/Services";
import Prescriptions from "../AppointmentConsultationProcess/tabs/Prescriptions/Prescriptions";
import Diagnoses from "../AppointmentConsultationProcess/tabs/Diagnoses/Diagnoses";
import Quotes from "../AppointmentConsultationProcess/tabs/Quotes/Quotes";
import Generals from "../AppointmentConsultationProcess/tabs/Generals/Generals";
import ModalConfirmationEdit from "../../modals/ModalAppointmentEarrings/ModalConfirmationEdit";
import ModalDateOfBirth from "../../modals/ModalDateOfBirth/ModalDateOfBirth";
import Allergies from "./tabs/Allergies/Allergies";
import LoadingDhn from "../../../../../@dhn/components/Loading/LoadingDhn";
import { isEmpty } from "lodash";
import PatientClinicalHistoryModal from "../../../components/clinical-history/PatientClinicalHistoryModal";
import DoctorsOfficePage from "../../../components/DoctorsOfficePage";

/** @params pageEdit: Nos permite discernir entre la pagina de editar y la de iniciar consulta **/
export default function AppointmentConsultationProcess({
  profile,
  user,
  center,
  dataDoctor,
  history,
  pageEdit,
  isPageModalHistory,
  appointmentIdSelectedInPageclinicHistory = null,
}) {
  const [{ state }, actions] = useAction(
    dataDoctor.medicalStaffId,
    dataDoctor.branchOfficeId,
    dataDoctor.centerId,
    pageEdit,
    history,
    appointmentIdSelectedInPageclinicHistory,
    isPageModalHistory,
  );

  const {
    dataAppointment,
    activeTab,
    activeTabPrescriptions,
    activeTabParameterEvaluation,
    tabDataParametersEvaluation,
    tabGenerals,
    tabServices,
    tabPrescription,
    tabDiagnoses,
    isLoadingTabs,
    tabAllergies,
    activeTabQuote,
    tabQuotes,
    isLoading,
    loadingButton2,
    isOpenModalRemoveServices,
    isOpenModalConfirmEdit,
    isOpenModalDateOfBirth,
    isClinicalHistoryModalOpen,
    isLoadingModalDateOfBirth,
    isLoadingModal,
    edited,
  } = state;

  const {
    onChange,
    onChangeTabParEvalu,
    onChangeTabServices,
    handleActionMutationAppointmentHistory,
    addToast,
    loadMedicines,
    handleAddMedicament,
    loadingSpecialties,
    loadMedicalStaffs,
    loadDiagnoses,
    onChangeTabQuotationQuantity,
    inputRef,
    handleLoadingModalClosed,
    handleExitConsultation,
    handleEndConsultation,
    handleLoadAppointmetRefetch,
    validateAvailableQuantity,
    handleSaveDateOfBirth,
    loadingAllergies,
    handleSelectMedicine,
    handleUpdateDeniesHistory,
  } = actions;

  const hasSavedConsultation =
    pageEdit || Boolean(dataAppointment?.isSaveAppointment);

  return (
    <div className="animated fadeIn">
      <LoadingDhn
        isOpen={isLoadingModal || isLoadingTabs || isEmpty(dataAppointment)}
        onClosed={handleLoadingModalClosed}
      />
      <ModalConfirmationEdit
        isOpen={isOpenModalConfirmEdit}
        {...{ handleEndConsultation }}
      />
      {!isPageModalHistory && (
        <ModalDateOfBirth
          isOpen={isOpenModalDateOfBirth}
          loading={isLoadingModalDateOfBirth}
          patientName={dataAppointment?.patient?.fullname}
          onSave={handleSaveDateOfBirth}
        />
      )}
      {!isPageModalHistory ? (
        <PatientClinicalHistoryModal
          isOpen={isClinicalHistoryModalOpen}
          toggle={() => onChange("isClinicalHistoryModalOpen", false)}
          patient={dataAppointment?.patient}
          {...{ profile, user, center, dataDoctor }}
        />
      ) : null}
      {!isPageModalHistory && (
        <NavbarDoctorOffice
          profile={profile}
          user={user}
          center={center}
          dataDoctor={dataDoctor}
        />
      )}
      <DoctorsOfficePage icon="fa-user-md" title="Citas Médicas">
        <Row form>
          <Col md={4}>
            <Label>Consultorio:</Label>
            <Input disabled value={dataDoctor?.branchOfficeName} />
          </Col>
        </Row>
        <Row form className="mt-4">
          <Col>
            <Card>
              <CardHeaderTabs
                onClick={(id) => onChange("activeTab", id)}
                active={activeTab}
                tabs={[
                  {
                    id: 1,
                    name: "General",
                  },
                  {
                    id: 2,
                    name: "Parámetros de Evaluación",
                  },
                  {
                    id: 3,
                    name: "Servicios",
                  },
                  {
                    id: 4,
                    name: "Prescripciones",
                  },
                  {
                    id: 5,
                    name: "Diagnósticos",
                  },
                  {
                    id: 6,
                    name: "Cotizaciones",
                    notShow: isPageModalHistory,
                  },
                  {
                    id: 7,
                    name: "Alergias",
                    notShow: isPageModalHistory,
                  },
                ]}
                {...{ activeTab }}
              />
              <CardBody className="pb-0">
                <TabContent className="border-0" {...{ activeTab }}>
                  <Generals
                    {...{
                      onChange,
                      dataAppointment,
                      tabGenerals,
                      isLoadingTabs,
                      pageEdit,
                      isPageModalHistory,
                    }}
                  />
                  <EvaluationParameters
                    activeTab={activeTabParameterEvaluation}
                    {...{
                      onChange,
                      tabDataParametersEvaluation,
                      activeTabParameterEvaluation,
                      onChangeTabParEvalu,
                      isPageModalHistory,
                    }}
                  />
                  <Services
                    appointmentId={dataAppointment?.id}
                    patientId={dataAppointment?.patientId}
                    {...{
                      onChangeTabServices,
                      onChange,
                      tabServices,
                      addToast,
                      handleLoadAppointmetRefetch,
                      isOpenModalRemoveServices,
                      validateAvailableQuantity,
                      isPageModalHistory,
                    }}
                  />
                  <Prescriptions
                    activeTab={activeTabPrescriptions}
                    patientId={dataAppointment?.patient?.id}
                    appointmentDate={dataAppointment?.appointmentDate}
                    appointmentId={dataAppointment?.id}
                    {...{
                      onChange,
                      loadMedicines,
                      tabPrescription,
                      handleAddMedicament,
                      loadingSpecialties,
                      loadMedicalStaffs,
                      inputRef,
                      isLoading,
                      pageEdit,
                      addToast,
                      isPageModalHistory,
                      handleSelectMedicine,
                      isLaboratoryLocked: Boolean(tabGenerals?.id),
                    }}
                  />
                  <Diagnoses
                    {...{
                      onChange,
                      tabDiagnoses,
                      loadDiagnoses,
                      isPageModalHistory,
                    }}
                    patientId={dataAppointment?.patientId}
                    isActive={activeTab === 5}
                  />
                  <Quotes
                    specialityId={dataAppointment?.specialityId}
                    medicalStaffId={dataDoctor?.medicalStaffId}
                    branchOfficeId={dataDoctor?.branchOfficeId}
                    activeTab={activeTabQuote}
                    activeTabFather={activeTab}
                    handleParentChange={onChange}
                    appointmentArsId={dataAppointment?.arsId}
                    appointmentId={dataAppointment?.id}
                    dataAddTabServices={
                      tabServices?.appointmentHistoryServices
                    }
                    {...{
                      tabQuotes,
                      onChangeTabQuotationQuantity,
                      isPageModalHistory,
                    }}
                  />
                  {activeTab === 7 && (
                    <Allergies
                      {...{
                        dataAppointment,
                        dataDoctor,
                        activeTab,
                        loadingAllergies,
                        handleUpdateDeniesHistory,
                      }}
                      data={tabAllergies?.data}
                      onChangeFather={onChange}
                    />
                  )}
                </TabContent>
              </CardBody>
              <CardFooter hidden={isPageModalHistory}>
                <Row form className="w-100">
                  <Col>
                    {edited && (
                      <Button
                        color="success"
                        className="btn-color-success"
                        disabled={isLoadingModal}
                        onClick={async () =>
                          await handleActionMutationAppointmentHistory()
                        }
                      >
                        {isLoadingModal ? (
                          <>
                            <i className="fa fa-spinner fa-spin" aria-hidden="true"></i>
                            {" Guardando..."}
                          </>
                        ) : (
                          <>
                            <i className="fa fa-floppy-o" />
                            {" Guardar"}
                          </>
                        )}
                      </Button>
                    )}
                    {!hasSavedConsultation && (
                      <Button
                        color="danger"
                        className={`${edited ? "ml-2 " : ""}btn-color-danger`}
                        disabled={isLoadingModal}
                        onClick={handleExitConsultation}
                      >
                        <i className="fa fa-times mr-2" />
                        Cerrar
                      </Button>
                    )}
                    {!edited && hasSavedConsultation && (
                      <Button
                        color="success"
                        className="ml-2"
                        disabled={loadingButton2}
                        onClick={() => handleEndConsultation({})}
                      >
                        {loadingButton2 ? (
                          <>
                            <i className="fa fa-spinner fa-spin" aria-hidden="true"></i>
                            {" Cargando..."}
                          </>
                        ) : (
                          <>
                            <i className="fa fa-sign-out mr-2" />
                            {" Finalizar Consulta"}
                          </>
                        )}
                      </Button>
                    )}
                  </Col>
                  <Col
                    className="d-flex justify-content-end align-content-center"
                  >
                    <Button
                      className="btn-color-gray text-white"
                      disabled={!dataAppointment?.patient?.id}
                      onClick={() =>
                        onChange("isClinicalHistoryModalOpen", true)
                      }
                    >
                      <i className="fa fa-history mr-2" />
                      Historia Clínica
                    </Button>
                  </Col>
                </Row>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </DoctorsOfficePage>
    </div>
  );
}
